
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 125"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"text-indent":"0","text-transform":"none","block-progression":"tb"},attrs:{"d":"M50 10c-22.11 0-40 17.88-40 40 0 8.342 2.544 16.058 7.063 22.688a2 2 0 01.25 1.718L13.25 88l13.313-4.594a2 2 0 011.718.219C34.517 87.671 41.981 90 50 90c22.12 0 40-17.88 40-40S72.12 10 50 10zM33.625 27.437l7.281 12.032-3.031 3a2 2 0 00-.313 2.406c4.626 8.01 10.107 14.243 17.782 17.625a2 2 0 002.218-.406l3.22-3.219 11.75 7.344c-1.302 2.928-2.998 4.671-4.938 5.687-2.248 1.177-4.993 1.4-8.125.75-6.265-1.299-13.833-6.223-20-12.531-6.167-6.308-10.94-13.979-12.157-20.219-.608-3.12-.34-5.807.813-7.937.992-1.835 2.677-3.405 5.5-4.532z","fill-rule":"evenodd","overflow":"visible","color":"#000"}})])
          )
        }
      }
    